/**
 * Rôles simulés localement. En production ils viennent des droits fins d'UniPortail
 * (claim `permissions["uniit"].actions`, format `uniit:domaine:action`) et le périmètre de
 * données vient du claim `teams` — voir docs/AUTH-UNIPORTAIL.md.
 * Le sélecteur de rôle de la maquette n'a de sens que tant que le SSO n'est pas branché.
 */
export type RoleId = 'admin' | 'gestion' | 'compta' | 'manager' | 'collab';

export interface Role {
  readonly id: RoleId;
  readonly user: string;
  readonly label: string;
}

export const ROLES: readonly Role[] = [
  { id: 'admin', user: 'Olivia Martin', label: 'Administrateur parc IT' },
  { id: 'gestion', user: 'Thomas Girard', label: 'Gestionnaire IT / support' },
  // Rôle exigé par SPEC-PIN-003 §3 : il approuve les commandes sans jamais en créer.
  { id: 'compta', user: 'Nadia Benali', label: 'Service comptable' },
  { id: 'manager', user: 'Sophie Lambert', label: 'Manager / RH' },
  { id: 'collab', user: 'Camille Roussel', label: 'Collaborateur' },
];

/** Écriture réservée à l'Admin parc IT et au Gestionnaire IT (SPEC-PIN-008 §3). */
export function canWrite(role: RoleId): boolean {
  return role === 'admin' || role === 'gestion';
}

/** La réforme est réservée à l'Administrateur parc IT (RM-PIN-006). */
export function canDecommission(role: RoleId): boolean {
  return role === 'admin';
}

/** Manager/RH et Responsable de service n'ont pas accès à l'export (SPEC-PIN-008 §6). */
export function canExport(role: RoleId): boolean {
  return role === 'admin' || role === 'gestion';
}

/**
 * RM-PIN-048 — seul le Service comptable approuve ou refuse une commande.
 *
 * ⚠️ SPEC-PIN-003 se contredit : la règle dit « seul un utilisateur du rôle Service comptable »,
 * alors que l'écran « File d'approbation budgétaire » (§6) liste aussi l'Administrateur parc IT en
 * écriture. C'est la règle qui est implémentée — écart à faire trancher.
 */
export function canApproveOrders(role: RoleId): boolean {
  return role === 'compta';
}
